import MuiFormControl from "@mui/material/FormControl";
const FormControl = MuiFormControl;
export default FormControl;
